import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { Button } from './ui/Button';
export const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setIsOpen(false);
    setActiveDropdown(null);
  }, [location]);
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'About Us',
    path: '/about'
  }, {
    name: 'Our Team',
    path: '/team'
  }, {
    name: 'Impact',
    path: '/impact'
  }, {
    name: 'Programs',
    path: '#',
    dropdown: [{
      name: 'Project AI for Kids',
      path: '/programs/students'
    }, {
      name: 'Project AI for Educators',
      path: '/programs/teachers'
    }]
  }, {
    name: 'AI Marketplace',
    path: '/blog'
  }, {
    name: 'Get Involved',
    path: '/contact'
  }];
  return <nav className={`fixed w-full z-50 transition-all duration-300 bg-white ${isScrolled ? 'shadow-md py-2' : 'py-3'}`} data-id="element-123">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-124">
        <div className="flex justify-between items-center" data-id="element-125">
          {/* Logo */}
          <Link to="/" className="flex items-center z-50" data-id="element-126">
            <img src="https://cdn.magicpatterns.com/uploads/x1YDvGzeVU8YQXVtyCccxo/f49a8e45-5d48-4cb5-9cfc-cafe1ddecaa2-removebg-preview.png" alt="AI For Kids Africa" className="h-12 w-auto" data-id="element-127" />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8" data-id="element-128">
            {navLinks.map(link => <div key={link.name} className="relative" onMouseEnter={() => link.dropdown && setActiveDropdown(link.name)} onMouseLeave={() => link.dropdown && setActiveDropdown(null)} data-id="element-129">
                <Link to={link.path} className="text-gray-600 hover:text-[#1C274C] font-bold text-sm transition-colors flex items-center" data-id="element-130">
                  {link.name}
                  {link.dropdown && <ChevronDown className="w-4 h-4 ml-1" data-id="element-131" />}
                </Link>

                {/* Dropdown */}
                {link.dropdown && <AnimatePresence data-id="element-132">
                    {activeDropdown === link.name && <motion.div initial={{
                opacity: 0,
                y: 10
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: 10
              }} className="absolute top-full left-0 mt-2 w-56 bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden py-2" data-id="element-133">
                        {link.dropdown.map(item => <Link key={item.name} to={item.path} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-[#1C274C]" data-id="element-134">
                            {item.name}
                          </Link>)}
                      </motion.div>}
                  </AnimatePresence>}
              </div>)}

            <div className="flex items-center space-x-3 ml-4" data-id="element-135">
              <a href="https://forms.gle/yiZQndnfYhzdQtX68" target="_blank" rel="noopener noreferrer" data-id="element-136">
                <Button variant="primary" size="sm" className="font-bold shadow-md hover:shadow-lg transform hover:-translate-y-0.5 transition-all" data-id="element-137">
                  Join Waitlist
                </Button>
              </a>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <button className="lg:hidden z-50 p-2 text-gray-700" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu" data-id="element-138">
            {isOpen ? <X className="w-7 h-7" data-id="element-139" /> : <Menu className="w-7 h-7" data-id="element-140" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && <div className="lg:hidden fixed inset-0 bg-white pt-24 px-6 overflow-y-auto z-40" data-id="element-141">
          <div className="flex flex-col space-y-6 text-center" data-id="element-142">
            {navLinks.map(link => <div key={link.name} data-id="element-143">
                {link.dropdown ? <>
                    <div className="text-lg font-bold text-[#1C274C] mb-2" data-id="element-144">
                      {link.name}
                    </div>
                    <div className="pl-4 flex flex-col space-y-3 border-l-2 border-gray-100" data-id="element-145">
                      {link.dropdown.map(item => <Link key={item.name} to={item.path} className="text-gray-600 hover:text-[#1C274C]" onClick={() => setIsOpen(false)} data-id="element-146">
                          {item.name}
                        </Link>)}
                    </div>
                  </> : <Link to={link.path} className="text-xl font-bold text-gray-800 hover:text-[#1C274C]" onClick={() => setIsOpen(false)} data-id="element-147">
                    {link.name}
                  </Link>}
              </div>)}
            <div className="pt-6 border-t border-gray-100" data-id="element-148">
              <a href="https://forms.gle/yiZQndnfYhzdQtX68" target="_blank" rel="noopener noreferrer" data-id="element-149">
                <Button className="w-full justify-center font-bold text-lg py-4" data-id="element-150">
                  Join Waitlist
                </Button>
              </a>
            </div>
          </div>
        </div>}
    </nav>;
};